import { numFixed } from '@/helpers/helpers'
import { i18n } from '@/locales/i18n'
import { parseISO, format as formatFns } from 'date-fns'
import { getCardsFromStr, getAllCards } from '@/helpers/cards'

// todo check if all locales are correct

export const numLocale = (num: number) => (num || 0).toLocaleString(i18n.global.locale || 'en-US')

export const numKtoM = (num: number, threshold: number = 10_000, toFixed: number = 1) => {
  const absolutNum = Math.abs(num)

  if (absolutNum > threshold) {
    if (absolutNum >= 1_000) {
      const divider = num >= 1_000_000 ? 1_000_000 : 1_000
      const unit = num >= 1_000_000 ? 'M' : 'K'
      num /= divider
      num = numFixed(num, toFixed) || 0
      return `${numLocale(num)}${unit}`
    }
  }

  return numFixed(num, toFixed)
}

export interface DateOptions {
  year?: 'numeric' | '2-digit'
  month?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow'
  day?: 'numeric' | '2-digit'
  hour?: boolean
  minute?: boolean
  second?: boolean
  timeZoneName?: string
  customFormat?: string
}
export const formatDate = (
  val: string,
  opts: DateOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: false,
    minute: false,
    second: false,
    timeZoneName: undefined,
  },
) => {
  if (val) {
    const parsed = parseISO(val)

    if (opts.customFormat) {
      return formatFns(parsed, opts.customFormat)
    }

    const options = {
      hour12: false,
      ...(opts.month ? { month: opts.month } : {}),
      ...(opts.day ? { day: opts.day } : {}),
      ...(opts.year ? { year: opts.year } : {}),
      ...(opts?.hour ? { hour: 'numeric' } : {}),
      ...(opts?.minute ? { minute: 'numeric' } : {}),
      ...(opts?.second ? { second: 'numeric' } : {}),
      ...(opts?.timeZoneName ? { timeZoneName: opts?.timeZoneName } : {}),
    }

    const localeStr = parsed.toLocaleString(
      i18n.global.locale,
      options as Intl.DateTimeFormatOptions,
    )
    return localeStr
  }
  return ''
}

export const getCards = (str: string) => {
  let res = getCardsFromStr(str)
  const allCards = getAllCards()
  res = (res || []).map((id: any) => allCards.find(c => c === id))
  return res
}

export const getPlayerHtmlPosition = position => {
  if (position === 'UTG+1') {
    return 'UTG1'
  }
  if (position === 'UTG+2') {
    return 'UTG2'
  }
  if (position === 'UTG+3') {
    return 'UTG3'
  }
  return position
}
